import type {Row} from '../../../../hooks/tanstack-table/helpers/types'
import type {MemexItemModel} from '../../../../models/memex-item-model'

/**
 * A sub-issue has a parent row that is not grouped.
 */
export const getIsSubIssue = (row: Row<MemexItemModel>): boolean => {
  const parentRow = row.getParentRow()
  return !!parentRow && !parentRow.getIsGrouped()
}
